<app-navigation> </app-navigation>

<mat-card class="card">
  <mat-card-content>
    <div class="header">
      <h1>Patientenübersicht</h1>
      <div class="right-elements">
        <button mat-flat-button color="primary" (click)="newPatient()">Neuer Patient</button>
      </div>
    </div>
    <div class="search">
      <input #search matInput (input)="applyFilter($event)" (keyup.enter)="openFirstPatient()" placeholder="Suche" />
      <mat-icon (click)="onClickSearch(search)" (keypress)="onClickSearch(search)" class="material-icons"
        >search</mat-icon
      >
    </div>
    <table mat-table [dataSource]="filteredPatientList()" class="mat-elevation-z8" aria-label="Patienten Liste">
      <!-- Sichtbarkeit -->
      <ng-container matColumnDef="visibility">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let patient">
          <mat-icon
            (click)="toggleVisibility(patient)"
            style="cursor: pointer"
            [attr.aria-label]="expandedPatient === patient ? 'Details sind sichtbar' : 'Details sind nicht sichtbar'">
            {{ expandedPatient === patient ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>Patienten ID</th>

        <td mat-cell *matCellDef="let patient">
          @if (expandedPatient === patient) {
            @if (patient.name === null || patient.name === undefined || patient.name === '') {
              {{ patient.uid }}
            } @else {
              {{ patient.name }}
            }
          } @else {
            {{ patient.uid }}
          }
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="birth">
        <th mat-header-cell *matHeaderCellDef>Geburtsmonat</th>
        <td mat-cell *matCellDef="let patient">
          @if (expandedPatient === patient) {
            {{ patient.birthDateIso | date: 'dd.MM.yyyy' }}
          } @else {
            {{ patient.birthMonth | monthString }} {{ patient.birthYear }}
          }
        </td>
      </ng-container> -->
      <ng-container matColumnDef="birth">
        <th mat-header-cell *matHeaderCellDef>Geburtsdatum</th>
        <td mat-cell *matCellDef="let patient">
          @if (expandedPatient === patient) {
            {{ patient.birthDateIso | date: 'dd.MM.yyyy' }}
          } @else {
            {{ patient.birthDateIso | decade }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="gender">
        <th mat-header-cell *matHeaderCellDef>Geschlecht</th>
        <td mat-cell *matCellDef="let patient">{{ patient.gender | genderString }}</td>
      </ng-container>

      <ng-container matColumnDef="buttons">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let patient">
          <div class="buttons">
            <button [routerLink]="['id/' + patient._documentId + '/reports/assessments']" mat-button color="basic">
              <span class="uppercase small">Akte öffnen</span>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button [routerLink]="['id/', patient._documentId]" mat-menu-item>
                <mat-icon>edit</mat-icon>
                <span>Patientendaten ändern</span>
              </button>
              <button (click)="deletePatient(patient)" mat-menu-item>
                <mat-icon>delete</mat-icon>
                <span>Patient löschen</span>
              </button>
            </mat-menu>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
  </mat-card-content>
</mat-card>
